export const BOTTOM_NAV_HEIGHT = 60
export const MAP_SEARCH_BAR_HEIGHT = 48

export const MARKER_WIDTH = 36
export const MARKER_HEIGHT = 45

export const CLUSTER_MARKER_SIZE = 60

/*
 * 한 기록에 붙일 수 있는 사진 수.
 *
 * 앱의 갤러리 선택 상한도 이 값을 따른다 — 웹이 remaining을 넘겨주고
 * 앱은 그대로 쓴다(webview_gallery_handler.dart). 서버는 개수를 막지 않는다.
 * 사진은 고르는 즉시 한 장씩 미리 올라가고 저장할 땐 주소만 보내므로
 * 늘려도 저장 요청은 커지지 않는다.
 */
export const MAX_PHOTOS = 10
export const MAX_DESCRIPTION_LENGTH = 100
